export const pretty = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (v === true) return "Yes";
  if (v === false) return "No";
  const s = String(v).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}${s.length > 10 ? ` ${s.slice(11, 16)}` : ""}`;
  if (!/^[a-z0-9_]+$/.test(s)) return s;
  return s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

export const sevOf = (i) => (i.severity === "medium" ? "moderate" : i.severity || "");

const BADGE = { open: "bg-[#5C4813] border-[#C2A462]", closed: "bg-[#26303D] border-[#526173]", low: "bg-[#153D2E] border-[#267A55]",
  moderate: "bg-[#5C4813] border-[#C2A462]", high: "bg-[#7C2D12] border-[#EA580C]", critical: "bg-[#7F1D1D] border-[#DC2626]" };

export function Badge({ v, testid }) {
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-white ${BADGE[v] || "bg-[#202734] border-[#354052] text-slate-300"}`} data-testid={testid}>{v ? pretty(v) : "—"}</span>;
}

export function Field({ label, value, full, long }) {
  return (
    <div className={`rounded-lg border border-[#2B3442] bg-[#171E29] px-3.5 py-2.5 ${full ? "sm:col-span-2" : ""}`}>
      <div className="mb-1.5 text-[10px] font-bold uppercase tracking-wider text-[#94A0B2]">{label}</div>
      <div className={`text-[15px] font-medium text-[#F5F5F5] ${long ? "whitespace-pre-wrap max-h-40 overflow-auto" : "truncate"}`}>{pretty(value)}</div>
    </div>
  );
}

export function EditBox({ label, full, children }) {
  return (
    <label className={`block rounded-lg border border-[#2B3442] bg-[#171E29] px-3.5 py-2.5 focus-within:border-[#C2A462] ${full ? "sm:col-span-2" : ""}`}>
      <div className="mb-1.5 text-[10px] font-bold uppercase tracking-wider text-[#94A0B2]">{label}</div>
      {children}
    </label>
  );
}

export const CTRL = "w-full bg-transparent text-[15px] text-[#F5F5F5] outline-none disabled:opacity-60 [&>option]:bg-[#171E29]";

export function Section({ title, children }) {
  return (
    <section className="mt-5 first:mt-0">
      <h3 className="mb-2.5 text-[11px] font-bold uppercase tracking-[0.07em] text-[#C2A462]">{title}</h3>
      <div className="grid gap-2.5 sm:grid-cols-2">{children}</div>
    </section>
  );
}

const RING = { default: "ring-transparent", active: "ring-[#4EA1FF]/70", done: "ring-[#3CCB7F]/70" };

export function Card({ eyebrow, title, sub, right, state = "default", testid, children }) {
  return (
    <div className={`rounded-xl border border-[#C2A462]/40 bg-[#111722] p-5 ring-2 ring-offset-2 ring-offset-[#0B0F17] transition-shadow ${RING[state]}`} data-testid={testid}>
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-[#2B3442] pb-4">
        <div><div className="text-[10px] font-bold uppercase tracking-widest text-[#C2A462]">{eyebrow}</div><h2 className="font-display text-xl font-semibold text-[#F5F5F5]">{title}</h2>{sub && <div className="mt-1 text-[13px] text-[#94A0B2]">{sub}</div>}</div>
        <div className="flex flex-wrap gap-1.5">{right}</div>
      </div>
      {children}
    </div>
  );
}

export function playClick() {
  try {
    const A = window.AudioContext || window.webkitAudioContext;
    if (!A) return;
    const ctx = new A(); const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = "square"; o.frequency.setValueAtTime(320, ctx.currentTime); o.frequency.exponentialRampToValueAtTime(180, ctx.currentTime + 0.035);
    g.gain.setValueAtTime(0.055, ctx.currentTime); g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.045);
    o.connect(g); g.connect(ctx.destination); o.start(); o.stop(ctx.currentTime + 0.045); o.onended = () => ctx.close();
  } catch (e) { /* audio unavailable */ }
}
